import React from "react";
import styled, { useTheme } from "styled-components";
import { Hand } from "lucide-react";
import ControlButton from "./ControlButton";
import { useTranslate } from '@tolgee/react';
import { ReactComponent as MuteMicrophoneActive } from "../../Assets/iconsv2/controlButtons/MuteMicActive.svg";
import { ReactComponent as MuteMicorphoneInactive } from "../../Assets/iconsv2/controlButtons/MuteMicInactive.svg";
import { ReactComponent as VideoActive } from "../../Assets/iconsv2/controlButtons/DisableVideoInactive.svg";
import { ReactComponent as VideoInactive } from "../../Assets/iconsv2/controlButtons/DisableVideoActive.svg";
import { ReactComponent as ShareScreenActive } from "../../Assets/iconsv2/controlButtons/ShareScreenActive.svg";
import { ReactComponent as ShareScreenInactive } from "../../Assets/iconsv2/controlButtons/ShareScreenInactive.svg";
import { ReactComponent as Participants } from "../../Assets/iconsv2/controlButtons/ParticipantsInactive.svg";
import { ReactComponent as ParticipantsOpen } from "../../Assets/iconsv2/controlButtons/ParticipantsActive.svg";

import { ReactComponent as MuteMicrophoneActiveLight } from "../../Assets/iconsv2/controlButtons/MuteMicActiveLight.svg";
import { ReactComponent as MuteMicorphoneInactiveLight } from "../../Assets/iconsv2/controlButtons/MuteMicInactiveLight.svg";
import { ReactComponent as VideoActiveLight } from "../../Assets/iconsv2/controlButtons/DisableVideoInactiveLight.svg";
import { ReactComponent as VideoInactiveLight } from "../../Assets/iconsv2/controlButtons/DisableVideoActiveLight.svg";
import { ReactComponent as ParticipantsLight } from "../../Assets/iconsv2/controlButtons/ParticipantsInactiveLight.svg";
import { ReactComponent as ParticipantsOpenLight } from "../../Assets/iconsv2/controlButtons/ParticipantsActiveLight.svg";
import { ReactComponent as ShareScreenActiveLight } from "../../Assets/iconsv2/controlButtons/ShareScreenActiveLight.svg";
import { ReactComponent as ShareScreenInactiveLight } from "../../Assets/iconsv2/controlButtons/ShareScreenInactiveLight.svg";
import { ReactComponent as SpotlightActive } from "../../Assets/iconsv2/controlButtons/spotlightActive.svg";
import { ReactComponent as SpotlightInactive } from "../../Assets/iconsv2/controlButtons/spotlightInactive.svg";
import { ReactComponent as SpotlightActiveLight } from "../../Assets/iconsv2/controlButtons/spotlightActiveLight.svg";
import { ReactComponent as SpotlightInactiveLight } from "../../Assets/iconsv2/controlButtons/spotlightInactiveLight.svg";

import { ReactComponent as ChatIconActive } from "../../Assets/iconsv2/controlButtons/ChatsActive.svg";
import { ReactComponent as ChatIconInactive } from "../../Assets/iconsv2/controlButtons/ChatsInactive.svg";
import { ReactComponent as ChatIconActiveLight } from "../../Assets/iconsv2/controlButtons/ChatsActiveLight.svg";  
import { ReactComponent as ChatIconInactiveLight } from "../../Assets/iconsv2/controlButtons/ChatsInactiveLight.svg";


import { ReactComponent as PollIconActive } from "../../Assets/iconsv2/controlButtons/PollBarsActive.svg";
import { ReactComponent as PollIconInactive } from "../../Assets/iconsv2/controlButtons/PollBarsInactive.svg";
import { ReactComponent as PollIconActiveLight } from "../../Assets/iconsv2/controlButtons/PollBarsActiveLight.svg";
import { ReactComponent as PollIconInactiveLight } from "../../Assets/iconsv2/controlButtons/PollBarsInactiveLight.svg";

import { ReactComponent as CloseCall } from "../../Assets/iconsv2/controlButtons/closeCall.svg";
import { ReactComponent as CogwheelIcon } from "../../Assets/iconsv2/controlButtons/cogwheel.svg"
import { ReactComponent as CogwheelIconLight } from "../../Assets/iconsv2/controlButtons/cogwheelLight.svg"

import { isSubscriptionLevelEnoughForAccessLevel } from "../../Helpers/subscriptions/SubscriptionsHelper";
import { ACCESS_LEVEL_PLATFORM, SEQUENCIAL_TRANSLATION, REAL_TIME_TRANSLATION } from "../../Constants/constantValues";
import { useAuthService } from "../../Context/AuthContext";
import OptionsControlButton from "./OptionsControlButton";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import MeetingOptionsButton from "./MeetingOptionsButton";


const RaiseHandIcon = ({ active }) => (
  <RaiseHandCircle $active={active}>
    <Hand size={16} />
  </RaiseHandCircle>
);

const ControlBar = ({
  handleMuteBtn,
  handleVideoBtn,
  handleShareScreenBtn,
  hansleParticipantsBtn,
  handleChatBtn,
  handlePollsBtn,
  handleCloseCallBtn,
  handleRaiseHandBtn,
  handRaised = false,
  isMeeting,
  isConference = false,
  isAttendee = false,
  videoEnabled,
  micEnabled,
  micAllowed = true,
  cameraAllowed = true,
  chatAllowed = true,
  pollsAllowed = false,
  isParticipantsOpen,
  isChatOpen,
  isPollsOpen = false,
  unreadChatCount,
  activePollBadge = false,
  translaionType,
  screenSharing,
  shareScreenAllowed = true,
  devices,
  selectedDevices,
  handleOpenOptionModal,
  handleSwitchGrid,
  grid,
  showSpotlight = false,
  showSettings = false,
  activeCallRef,
  handleRecordBtn,
  isRecording,
  isRecordingLoading = false,
  // Meeting options props
  meetingId,
  aiSummaryEnabled = false,
  transcriptExportEnabled = false,
  onToggleAiSummary,
  onToggleTranscriptExport,
  showChatToggleMenu = false,
  chatEnabled = true,
  onToggleChat,
}) => {

  const { subscriptionLevel } = useAuthService();
  const { theme } = useGenericComponentsStateService()
  const { t } = useTranslate();

  return (
    <ControlsContainer>
      {!isAttendee && translaionType !== SEQUENCIAL_TRANSLATION && (
        <ControlButton
          active={!micEnabled}
          activeIcon={theme === "light" ? <MuteMicorphoneInactiveLight /> : <MuteMicorphoneInactive />}
            inactiveIcon={theme === "light" ? <MuteMicrophoneActiveLight /> : <MuteMicrophoneActive />}
          label={t('call_modal.mic')}
          onClick={handleMuteBtn}
        />
      )}
      {!isAttendee && (
        <ControlButton
          active={videoEnabled}
          activeIcon={theme === "light" ? <VideoActiveLight /> : <VideoActive />}
          inactiveIcon={theme === "light" ? <VideoInactiveLight /> : <VideoInactive />}
          label={t('general.video')}
          disabled={!cameraAllowed}
          onClick={handleVideoBtn}
        />
      )}

      {(!isAttendee || showSpotlight) && (
        <ControlButton
          active={grid}
          activeIcon={theme === "light" ? <SpotlightActiveLight /> : <SpotlightActive />}
          inactiveIcon={theme === "light" ? <SpotlightInactiveLight /> : <SpotlightInactive />}
          label={t('call_modal.spotlight')}
          onClick={handleSwitchGrid}
        />
      )}

      {!isAttendee &&
        (isSubscriptionLevelEnoughForAccessLevel(subscriptionLevel, ACCESS_LEVEL_PLATFORM) || isMeeting || isConference) &&
        <ControlButton
          active={screenSharing}
          activeIcon={theme === "light" ? <ShareScreenActiveLight /> : <ShareScreenActive />}
          inactiveIcon={theme === "light" ? <ShareScreenInactiveLight /> : <ShareScreenInactive />}
          label={t('call_modal.share_screen')}
          disabled={!shareScreenAllowed}
          onClick={handleShareScreenBtn}
        />
      }

      {!isAttendee && (
        <ControlButton
          active={handRaised}
          activeIcon={<RaiseHandIcon active />}
          inactiveIcon={<RaiseHandIcon />}
          label={t(handRaised ? 'call_modal.lower_hand' : 'call_modal.raise_hand')}
          onClick={handleRaiseHandBtn}
        />
      )}

      {!isAttendee && (
        <ControlButton
          active={isParticipantsOpen}
          activeIcon={theme === "light" ? <ParticipantsOpenLight /> : <ParticipantsOpen />}
          inactiveIcon={theme === "light" ? <ParticipantsLight /> : <Participants />}
          label={t('call_modal.participants')}
          onClick={hansleParticipantsBtn}
        />
      )}

      {chatAllowed  && (
        <ControlButtonWrapper>
          <ControlButton
            active={isChatOpen}
            activeIcon={theme === "light" ? <ChatIconActiveLight /> : <ChatIconActive />}
            inactiveIcon={theme === "light" ? <ChatIconInactiveLight /> : <ChatIconInactive />}
            label={t('call_modal.chat_option')}
            onClick={handleChatBtn}
          />
          
          {unreadChatCount > 0 && !isChatOpen && (
            <UnreadBadge />
          )}
        </ControlButtonWrapper>
      )}

      {(!isAttendee || showSettings) && (
        <OptionsControlButton
          active={true}
          activeIcon={theme === "light" ? <CogwheelIconLight /> : <CogwheelIcon />}
          devices={devices}
          selectedDevices={selectedDevices}
          label={t('general.settings')}
          handleOpenOptionModal={handleOpenOptionModal}
        />
      )}

      {(isMeeting || showChatToggleMenu) && (
        <MeetingOptionsButton
          isMeeting={isMeeting}
          meetingId={meetingId}
          aiSummaryEnabled={aiSummaryEnabled}
          transcriptExportEnabled={transcriptExportEnabled}
          onToggleAiSummary={onToggleAiSummary}
          onToggleTranscriptExport={onToggleTranscriptExport}
          isRecording={isRecording}
          isRecordingLoading={isRecordingLoading}
          handleRecordBtn={handleRecordBtn}
          chatToggleEnabled={showChatToggleMenu}
          chatEnabled={chatEnabled}
          onToggleChat={onToggleChat}
        />
      )}

      
      {pollsAllowed && (
        <ControlButtonWrapper>
          <ControlButton
            active={isPollsOpen}
            activeIcon={theme === "light" ? <PollIconActiveLight /> : <PollIconActive />}
            inactiveIcon={theme === "light" ? <PollIconInactiveLight /> : <PollIconInactive />}
            label={t('conferences.polls')}
            onClick={handlePollsBtn}
          />
          
          {activePollBadge && !isPollsOpen && (
            <ActivePollBadge />
          )}
        </ControlButtonWrapper>
      )}

      <ControlButton
        active={true}
        activeIcon={<CloseCall />}
        onClick={handleCloseCallBtn}
      />
    </ControlsContainer>
  );
};

export default ControlBar;

const RaiseHandCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: ${({ $active, theme }) =>
    $active
      ? theme.callComponent.controlButtonBackgroundActive
      : theme.callComponent.controlButtonBackgroundInactive};

  && svg {
    fill: none;
    color: ${({ $active, theme }) =>
      $active
        ? theme.callComponent.controlButtonIconActive
        : theme.callComponent.controlButtonIconInactive};
  }
`;

const ControlsContainer = styled.div`
  display: flex;
  align-items: start;
  justify-content: flex-start;
  width: 100%;
  padding: 8px 0;

  height: 80px;
  background: ${({ theme }) => theme.menu.background};
  border-top: 1px solid  ${({ theme }) => theme.sidebar.borderColor};
  gap: 25px;
  margin-top: auto;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &::before,
  &::after {
    content: "";
    margin: auto;
  }
`;

const ControlButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const UnreadBadge = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 12px;
  height: 12px;
  background: #FF3B30;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.menu.background};
  pointer-events: none;
`;

const ActivePollBadge = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 12px;
  height: 12px;
  background: #FF3B30;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.menu.background};
  pointer-events: none;
`;